export default __webpack_public_path__ + "static/media/customer-service-skills.one-half.70c963eb.png";